import { Box, Button, Text } from '@stitch-fix/mode-react';

export type JoinUsCtaProps = {
  title: string;
  cta: {
    text: string;
    href: string;
  };
};

export const JoinUsCta = ({ title, cta }: JoinUsCtaProps) => (
  <Box
    m="0 auto"
    p="2.5rem 1.5rem"
    style={{ textAlign: 'center' }}
    bgColor="gray-95"
  >
    <Text as="h2" mb={1} setting="title-medium">
      {title}
    </Text>
    <Button as="a" variant="filled-staple" width="fit" href={cta.href}>
      {cta.text}
    </Button>
  </Box>
);
